import { documentPageMetadataUserEditStatusSchema } from 'features/knowledgeDocumentViewer/types/documentMetadataUserEditSchemas'

export const dataLabelingLabelStatusSchema =
  documentPageMetadataUserEditStatusSchema
